<div class="text-box">
    <p>{{ 'SHOP.SHARED.EVENTS.PREVENT_CHANGE_MONTH.P1' | translate }}</p>
</div>
<div class="text-box">
    <p>{{ 'SHOP.SHARED.EVENTS.PREVENT_CHANGE_MONTH.P2' | translate }}</p>
</div>
<div class="text-box">
    <p>{{ 'SHOP.SHARED.EVENTS.PREVENT_CHANGE_MONTH.P3' | translate }}</p>
</div>
